import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectorRef } from '@angular/core';
import cloneDeep from 'lodash/cloneDeep';
import { ConfirmationService, MessageService, MenuItem, TreeNode } from 'primeng/api';
import { DataService } from 'src/app/services/data.service';
import { ExportService } from 'src/app/services/export.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { OrgUnitsService } from 'src/app/services/org-units.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslatorPipe } from 'src/app/services/translator.pipe';

@Component({
  selector: 'app-create-periodic-reports',
  templateUrl: './create-periodic-reports.component.html',
  styleUrl: '../preodic-reports.component.scss'
})
export class CreatePeriodicReportsComponent implements OnInit {
  
  treeData: any[] = [];
  GlobalConstants = GlobalConstants;
  staticURL = GlobalConstants.staticFilesURL;
  periodicReportForm: FormGroup;
  isManagerMode = false;
  @Input() mode: string = 'create';
  managers: any[] = [];
  selectedTreeData : any = [];
  selectedTreeTags_current: any;
  selectedTreeData_orginal: any;
  types: any[] = [];
  selectedTreeTags: MenuItem[] = [];
  currentDate = new Date();
  enhancedDate!: Date;
  contentUpdateData: any[] = [];
  @Input() report: any;
  isCreate: boolean = false;
  loading: boolean = false;
  uid: string = '';
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter<boolean>();
  
  constructor(
    private dataService: DataService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private orgUnits: OrgUnitsService,
    private permissionService: PermissionHandlerService,
    private exportService: ExportService,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef
  ) {
    this.periodicReportForm = this.fb.group({
      ou: ['', Validators.required],
      manager: [''],
      days: ['', Validators.required],
      time: ['', Validators.required],
      confirmation: [{value: false, disabled: !this.isManagerMode}],
      reportForm: [''],
      comment: [{value: '', disabled: !this.isManagerMode}],
      agreement: [{value: false, disabled: !this.isManagerMode}],
      status: ['PENDING']
    });
  }


  ngOnInit() {
    this.loading = true;
    this.uid= localStorage.getItem('uid') || '';
    Promise.all([
      this.getTreeData(),
    ]).then(e => {

          if(this.mode == 'Manager'){
            this.isManagerMode = true;
            this.report.status !== 'SIGNED' ? this.enableManagerControls() : this.disableManagerControls();
          }else if(this.mode == 'create'){
            this.isCreate = true;
            this.isManagerMode = false;
            this.disableManagerControls();
          }else{
            this.isManagerMode = false;
            if(this.report?.status !== 'SIGNED' && this.checkAdminManagerMode()){
              this.mode = 'Manager'
              this.enableManagerControls();
            } else {
              this.disableManagerControls();
            }
          }
      

          if(this.report?.status == 'SIGNED'){
            this.disableAllControls();
          }
      
          if(this.mode !== 'create'){
            this.periodicReportForm.get('ou')?.disable();
            this.setReportData();
          }
      
          this.periodicReportForm.get('days')?.valueChanges.subscribe(days => {
            if(days < 0){
              this.periodicReportForm.get('days')?.setValue(0);
            };
            this.calculateDateTime();
          });

          this.periodicReportForm.get('time')?.valueChanges.subscribe((value: Date) => {
            if (value) {
              const newTime = new Date(value);
              newTime.setMinutes(0); // Always set minutes to 00
      
              // Update the form value without triggering an infinite loop
              if (newTime.getTime() !== value.getTime()) {
                this.periodicReportForm.get('time')?.setValue(newTime, { emitEvent: false });
              }
            }
          });

          this.loading = false;
    });

  }


   checkAdminManagerMode(){
   let allowedOus = this.flattenTree(this.selectedTreeData)
   return allowedOus.includes(this.report.ou._id) && this.hasPermission('CONTENT_APPROVE','a')
   }


   flattenTree(root: TreeNode[]): any[] {
    const result: any[] = [];
    root?.map(e => this.flattenNode(e, result))
    // this.flattenNode(root, result);
    return result;
  }

  private flattenNode(node: TreeNode, result: any[]): void {
    result.push((node as any)?._id);
    if(node?.children){
      for (const child of node.children) {
        this.flattenNode(child, result);
      }
    }
  }

  disableAllControls(){
    this.periodicReportForm.get('ou')?.disable();
    this.periodicReportForm.get('manager')?.disable();
    this.periodicReportForm.get('days')?.disable();
    this.periodicReportForm.get('time')?.disable();
  }

  hasPermission(key:string, flag:string) {
    return this.permissionService.hasPermission(key, flag);
  }

  async setReportData(){
   if(!this.report){
    return;
   }
  

    this.periodicReportForm.patchValue({
      ou: this.findNodeById(this.treeData, this.report.ou._id),
      manager: this.report?.manager,
      days: this.report.days,
      time: this.report.time,
      status: this.report.status,
      comment: this.report?.comment,
      agreement: this.report?.agreement,
      confirmation: this.report?.confirmation,
    });

    this.contentUpdateData = this.report.states;
    this.enhancedDate = new Date(this.report.sendingDate);
    const timeObj = this.convertTimeStringToDate(this.report.time);
    this.periodicReportForm.get('time')?.setValue(timeObj);

    // await this.getManagers(this.report.ou).then(e => {
    //   this.periodicReportForm.get('manager')?.setValue(this.report.manager);
    //  });

     this.cdr.detectChanges();
  
  }

  convertTimeStringToDate(timeString: string): Date {
    const [time, period] = timeString.split(' ');
    const [hours, minutes] = time.split(':');
    const date = new Date();
    date.setHours(period === 'PM' ? parseInt(hours) + 12 : parseInt(hours));
    date.setMinutes(parseInt(minutes)); 
    return date;
  }
  
  findNodeById(data: any[], nodeId: string): any | undefined {
    for (const node of data) {
      if (node._id === nodeId) {
        return node;
      }
      if (node.children) {
        const result = this.findNodeById(node.children, nodeId);
        if (result) {
          return result;
        }
      }
    }
    return undefined;
  }

  disableDates(date: Date): boolean {
    return date > this.currentDate;
  }

  calculateDateTime() {
    const startDate = new Date(this.currentDate);
    let daysToAdd = this.periodicReportForm.get('days')?.value;

    // Adjust days if they fall on Friday or Saturday
    const currentDay = startDate.getDay();
    if (currentDay === 5) { // Friday
      daysToAdd += 2; // Move to Sunday
    } else if (currentDay === 6) { // Saturday
      daysToAdd += 1; // Move to Sunday
    }

    startDate.setDate(startDate.getDate() + daysToAdd);
    this.enhancedDate = startDate;
  }
  get status(): string {
    return this.periodicReportForm.get('status')?.value || 'PENDING';
  }

  async getContentUpdates() {
    try {

      if(!!this.report && this.report?.status == 'SIGNED'){
        this.contentUpdateData = this.report.states;
        return;
      }

      const selectedEntity = this.periodicReportForm.get('ou')?.value;

      if(!selectedEntity){
        this.messageService.add({
          severity: 'error',
          summary: this.translate('Error'),
          detail: this.translate('Please select an entity')
        });
        return;
      }
      
      // Flatten entity tree to get all OUs
      let ousArray: any[] = [];
      if (selectedEntity) {
        ousArray = this.flattenEntityTree(selectedEntity);
      }

      
      // Make API calls for each type
      const types = ['OU CHANGE', 'EDIT', 'ADD SERVICE', 'DELETE'];
      const responses = await Promise.all(types.map(type => {
        let filers : any = {
          type: type,
          ous: ousArray,
          status: 'APPROVED'
        }
        if(this.periodicReportForm.get('reportForm')?.value){
          filers.createdAt = {
            $gte: this.periodicReportForm.get('reportForm')?.value
          }
        }
        return this.dataService.postData('content-update/get?offset=2&page=1',filers)}
      ));

      // Process responses
      let statsData: any = ['OU CHANGE', 'EDIT', 'ADD SERVICE', 'DELETE']

      let finalData: any = [];
      

      responses.forEach((res, index) => {
        if (!res.error && res.data[0]) {
          const type = types[index];
          
          // Store stats for this specific type
          if (res.data[0].stats_type) {
            const typeStat = res.data[0].data_type
            if (typeStat) {
              finalData.push({
                data: typeStat,
                type: type
              });
            }
          }

          // Add to total
          if (res.data[0].total) {
            statsData.total += res.data[0].total;
          }

        }
      });

      // Store processed data
      this.contentUpdateData = finalData;
      console.log("===>finalData",finalData);
     //debugger
    } catch (error) {
      console.error('Error in getContentUpdates:', error);
    }
  }


  

  // Helper method to flatten entity tree
  private flattenEntityTree(entity: any): string[] {
    let ousArray: string[] = [];
    
    if (entity._id) {
      ousArray.push(entity._id);
    }

    if (entity.children && Array.isArray(entity.children)) {
      entity.children.forEach((child: any) => {
        ousArray = ousArray.concat(this.flattenEntityTree(child));
      });
    }

    return ousArray;
  }


  enableManagerControls() {
    this.periodicReportForm.get('confirmation')?.enable();
    this.periodicReportForm.get('comment')?.enable();
    this.periodicReportForm.get('agreement')?.enable();
  }

  disableManagerControls() {
    this.periodicReportForm.get('confirmation')?.disable();
    this.periodicReportForm.get('comment')?.disable();
    this.periodicReportForm.get('agreement')?.disable();
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  async getManagers(id?: any) {
    try {

      const entityValue = this.periodicReportForm.get('ou')?.value ? this.periodicReportForm.get('ou')?.value : id;
  
      let res = await this.dataService.getData('ou/manager?id='+ entityValue._id);
      if (!res.error) {
        this.managers = res.data[0].managers.map((manager: any) => {
          return {
            _id: manager._id,
            name: manager.name.first + ' ' + manager.name.middle + ' ' + manager.name.last,
            email: manager.email
          };
        });
        this.periodicReportForm.get('manager')?.reset();
      }
     else {
        this.messageService.add({
          severity: 'error', 
          summary: this.translate('Error'),
          detail: this.translate('No managers found for this entity')
        });
        this.managers = [];
      }

      return 
    } catch (error) {
      console.log('Error fetching managers:', error);
      this.messageService.add({
        severity: 'error',
        summary: this.translate('Error'),
        detail: this.translate('Failed to load managers')
      });
    }
  }

  

  submitForm() {
    if (this.mode === 'Manager' && this.report.status !== 'SIGNED') {
      this.updateManager();
      return;
    }

    if (this.isCreate) {
      this.createReport();
      return;
    }

    if (this.mode === 'Admin' && this.report.status !== 'SIGNED') {
      this.updateAdmin();
      return;
    }

    this.closeModal.emit(true);
  }

  async updateAdmin(){
    try {
      const formData = this.periodicReportForm.value;
      if(!this.validateForm(formData)){
        return;
      }
      let data : any = {
        ou: formData.ou._id,
        days: formData.days,
        time: new Date(formData.time).toLocaleTimeString('en-US', { hour12: true, hour: '2-digit', minute: '2-digit' }),
        sendingDate: this.enhancedDate.toISOString(),
        status: 'PENDING',
        reportForm: this.report.reportForm,
        reportTo: this.currentDate.toISOString(),
        states : this.contentUpdateData,
        // manager: formData.manager
      }

      if (this.uid === this.report.manager._id && this.report.status !== 'SIGNED') {
        data.confirmation = formData.confirmation
        data.comment = formData.comment
        data.agreement = formData.agreement
        data.status = 'SIGNED'
      }


      const response = await this.dataService.postData('content-update-reports/'+this.report._id, data,'PUT');
      if(!response.error){
        this.messageService.add({
          severity: 'success', 
          summary: this.translate('Success'),
          detail: this.translate('Report updated successfully')
        });
        this.closeModal.emit(true);
      }else{
        this.messageService.add({
          severity: 'error',
          summary: this.translate('Error'), 
          detail: this.translate('Failed to update report')
        });
      }
    } catch (error) {
      console.error('Error in updateAdmin:', error);
      this.messageService.add({
        severity: 'error',
        summary: this.translate('Error'),
        detail: this.translate('Failed to update report')
      });
    }
  }

  async updateManager(){
    try {
      const formData = this.periodicReportForm.value;
      if(!this.validateForm(formData)){
        return;
      }
      let data = { 
       confirmation: formData.confirmation,
       comment: formData.comment,
       agreement: formData.agreement,
       status: 'SIGNED',
       manager: {
        _id : localStorage.getItem('uid') || '',
        name: localStorage.getItem('username') || '',
        email: localStorage.getItem('email') || ''
       }
      }
      const response = await this.dataService.postData('content-update-reports/'+this.report._id, data,'PUT');
      if(!response.error){
        this.messageService.add({
          severity: 'success',
          summary: this.translate('Success'),
          detail: this.translate('Manager updated successfully')
        });
        this.closeModal.emit(true);
      }else{
        this.messageService.add({
          severity: 'error',
          summary: this.translate('Error'),
          detail: this.translate('Failed to update manager')
        });
      }
    } catch (error) {
      console.error('Error in updateManager:', error);
      this.messageService.add({
        severity: 'error',
        summary: this.translate('Error'),
        detail: this.translate('Failed to update manager')  
      });
    }
  } 

  checkIfDataEmpty(){
    const allDataEmpty = this.contentUpdateData.every(update => update.data.length === 0);
    if (allDataEmpty) {
      this.messageService.add({
        severity: 'error',
        summary: this.translate('Error'),
        detail: this.translate('No data found')
      });
        return true;
    }
    return false;
  }

  async createReport() {
    try {
      const formData = this.periodicReportForm.value;
      if(!this.validateForm(formData)){
        return;
      }
      let data = {
        ou: formData.ou._id,
        // manager: formData.manager,
        days: formData.days,
        time: new Date(formData.time).toLocaleTimeString('en-US', { hour12: true, hour: '2-digit', minute: '2-digit' }),
        status: formData.status,
        sendingDate : this.enhancedDate.toISOString(),
        reportForm: this.periodicReportForm.get('reportForm')?.value || 'New Report form started',
        reportTo: this.currentDate.toISOString(),
        states : this.contentUpdateData
      }

      if(this.checkIfDataEmpty()){
       data.status = 'NO_DATA'
      }

      const response = await this.dataService.postData('content-update-reports/',  data);
      
      if (!response.error) {
        this.messageService.add({
          severity: 'success',
          summary: this.translate('Success'),
          detail: this.translate('Report created successfully')
        });
        this.closeModal.emit(true);

      } else {
        this.messageService.add({ 
          severity: 'error',
          summary: this.translate('Error'),
          detail: this.translate('Failed to create report')
        });
      }
    } catch (error) { 
      console.error('Error in createReport:', error);
      this.messageService.add({
        severity: 'error',
        summary: this.translate('Error'),
        detail: this.translate('Failed to create report')
      });
    } 
  }
  

  validateForm(formData: any  ) {
    if(this.isCreate){
      if(!formData.ou){
        this.messageService.add({
          severity: 'error',
          summary: this.translate('Error'),
          detail: this.translate('Please select an entity')
        });
        return false;
      }

      if(!formData.days){
        this.messageService.add({
          severity: 'error',
          summary: this.translate('Error'),
          detail: this.translate('Please select a number of days')
        });
        return false;  
      }

      if(!formData.time){
        this.messageService.add({
          severity: 'error',
          summary: this.translate('Error'),
          detail: this.translate('Please select a time')
        });
        return false;
      }
    }
    if(this.mode == 'Manager'){
      if(!formData.confirmation){
        this.messageService.add({
          severity: 'error',
          summary: this.translate('Error'),
          detail: this.translate('Please confirm the report')
        });
        return false;
      }
      if(!formData.comment){
        this.messageService.add({
          severity: 'error',
          summary: this.translate('Error'),
          detail: this.translate('Please add comments')
        });
        return false;
      }
      if(!formData.agreement){
        this.messageService.add({
          severity: 'error',
          summary: this.translate('Error'),
          detail: this.translate('Please agree to the terms and conditions')
        });
        return false;
      }
    }
    return true;  
  }


  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }

  async getTreeData() {
    this.treeData = await this.permissionService.extractOUChildren('CONTENT_UPDATE_LOGS', 'r');
    this.selectedTreeData_orginal = cloneDeep(this.treeData)
    this.changeSelectedTag(null);
    console.log("===>test data d",this.selectedTreeData);
  }

  findNodeByName(data: any[], nodeName: any): any | undefined {
    for (const node of data) {
      if (node.children) {
        const result = this.findNodeByName(node.children, nodeName);
        if (result) {
          return result;
        }
      }
    }
    return undefined;
  }

  async changeSelectedTag(event: any) {
    console.log("change tag event", event);
    this.selectedTreeTags_current = {
      "label": "Ministries/Entities"
    };
    if (this.selectedTreeTags_current.label) {
      console.log("change tag event1", event,this.selectedTreeData);
      await this.filterTreeByTag("Ministries/Entities");
    } else {
      this.selectedTreeData = null;
    }
  }

  filterTreeByTag(tag: string) {
    this.selectedTreeData = cloneDeep(this.selectedTreeData_orginal);
    this.selectedTreeData = this.selectedTreeData
      .map((node: any) => this.filterNodes(node, tag))
      .filter((filteredNode: any) => filteredNode !== null);
    console.log(this.selectedTreeData);

    if (this.selectedTreeData.length == 0) {
      let cloneitems: any = []
      this.selectedTreeData_orginal.forEach((item: any) => {
        cloneitems.push({
          data: item.data,
          id: item.id,
          label: item.label,
          parent: item.parent,
          tag: item.tag,
          _id: item._id,
          children: []
        })
      });

      console.log("cloneitems.children", cloneitems);
      this.selectedTreeData = cloneDeep(cloneitems);
      console.log("cloneitems.children this.selectedTreeData", this.selectedTreeData);
    }
  }

  filterNodes(node: any, tag: string): any | null {
    if (node.children && node.children.length > 0) {
      node.children = node.children
        .map((childNode: any) => this.filterNodes(childNode, tag))
        .filter((filteredChild: any) => filteredChild !== null);
    }

    if (node.tag === tag || (node.children && node.children.length > 0)) {
      return node;
    }
    return null;
  }

}
